<script setup lang="ts">
import { useRoute } from 'vue-router'
import { ref, computed, watch } from 'vue'
import LogoLight from '../assets/images/Logo-Kontroll-Light.png'
import LogoDark from '../assets/images/Logo-Kontroll-Dark.png'
import LogoIconLight from '../assets/icons/logo_inverted.png'
import LanguageSelector from '@/components/language/LanguageSelector.vue'

const route = useRoute()

const steps = [
  { name: 'Inicio', route: 'onboarding-start' },
  { name: 'Empresa', route: 'onboarding-company' },
  { name: 'Industria', route: 'onboarding-industry' },
  { name: 'Volumen', route: 'onboarding-volume' },
  { name: 'Referencias', route: 'onboarding-references' },
  { name: 'Problemas', route: 'onboarding-problems' },
  { name: 'Fuente', route: 'onboarding-source' },
  { name: 'Completado', route: 'onboarding-complete' }
]

const currentStep = computed(() => 
  steps.findIndex(step => step.route === route.name) + 1
)

const currentTheme = ref(localStorage.getItem('theme') || 'light')
const currentLogo = computed(() => currentTheme.value === 'dark' ? LogoDark : LogoLight)

// Watch for theme changes in localStorage
watch(
  () => localStorage.getItem('theme'),
  (newTheme) => {
    currentTheme.value = newTheme || 'light'
  }
)
</script>

<template>
  <div class="min-h-screen bg-secondary-50 dark:bg-secondary-900">
    <!-- Progress bar -->
    <div class="fixed top-0 left-0 right-0 h-2 bg-secondary-200 dark:bg-secondary-800">
      <div 
        class="h-full bg-primary-600 transition-all duration-500"
        :style="{ width: `${(currentStep / steps.length) * 100}%` }"
      ></div>
    </div>
    <div class="absolute top-4 right-4">
      <LanguageSelector />
    </div>


    <!-- Logo -->
    <div class="pt-8 px-4">
      <RouterLink to="/" class="block w-fit mx-auto">
        <div class="transition-all duration-300 flex justify-center">
            <img 
              :src="LogoIconLight" 
              alt="Kontroll" 
              class="h-10 w-auto"
            />
            <p class="font-kalperica text-3xl mt-1 font-normal tracking-wider"

            >Kila</p>
          </div>
      </RouterLink>
    </div>

    <!-- Content -->
    <RouterView v-slot="{ Component }">
      <Transition
        enter-active-class="transition-opacity duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-300"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <component :is="Component" />
      </Transition>
    </RouterView>
  </div>
</template>